export default "__VITE_ASSET__dgXx2vAf__"